exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".UserCard-header-3Ojvr .UserCard-container-7VvvC{overflow:hidden}.UserCard-header-3Ojvr .UserCard-action-3iQ7A{float:right}.UserCard-header-3Ojvr .UserCard-action-3iQ7A a{margin-left:10px}.UserCard-label-2FNc5{padding:10px 0}.UserCard-label-2FNc5 h5{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.UserCard-status-1rygs{float:right}", ""]);

// exports
exports.locals = {
	"header": "UserCard-header-3Ojvr",
	"container": "UserCard-container-7VvvC",
	"action": "UserCard-action-3iQ7A",
	"label": "UserCard-label-2FNc5",
	"status": "UserCard-status-1rygs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/company/components/UserCard.less
// module id = 1636
// module chunks = 0